// removed by extract-text-webpack-plugin
module.exports = {"opportunity_item":"src-components-opportunity-item----opportunity-item-module---opportunity_item---3DyT_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/opportunity-item/opportunity-item.module.scss
// module id = 281
// module chunks = 79518935032921 185408970092611